import { memo } from 'react';

import { List, Typography } from 'antd';

import styles from './styles.module.scss';

const { Text } = Typography;

function GeofenceDetailsListItem({ label, value }) {
  return (
    <List.Item>
      <Text strong className={styles['item-name']}>
        {label}
      </Text>
      {value}
    </List.Item>
  );
}

export default memo(GeofenceDetailsListItem);
